module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.data), function(menuItem, index) {
    return _c('div', {
      key: menuItem.id
    }, [(menuItem.children == null) ? _c('Menu-item', {
      attrs: {
        "name": menuItem.id
      }
    }, [_c('Icon', {
      class: {
        'menuitem-icon': ((_vm.lvl != 1) || (_vm.mainMenuType.value == _vm.mainMenuType.FULLWIDTH)),
        'menuitem-icon-big': ((_vm.lvl == 1) && (_vm.mainMenuType.value == _vm.mainMenuType.NARROW))
      },
      attrs: {
        "type": menuItem.icon
      }
    }), _vm._v(" "), ((_vm.mainMenuType.value == _vm.mainMenuType.FULLWIDTH) || (_vm.lvl != 1)) ? _c('span', {
      staticClass: "menuitem-text"
    }, [_vm._v(_vm._s(menuItem.name))]) : _vm._e(), _vm._v(" "), ((menuItem.closable == true)) ? _c('Button', {
      staticClass: "menuitem-close-button",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.deleteItemOnClick(menuItem.id)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "close-round"
      }
    })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((menuItem.children != null) && (menuItem.isGroup != true) && (_vm.mainMenuType.value == _vm.mainMenuType.FULLWIDTH)) ? _c('Submenu', {
      attrs: {
        "name": menuItem.id
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('Icon', {
      staticClass: "menuitem-icon",
      attrs: {
        "type": menuItem.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "menuitem-text"
    }, [_vm._v(_vm._s(menuItem.name))]), _vm._v(" "), ((menuItem.closable == true)) ? _c('Button', {
      staticClass: "menuitem-close-button",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.deleteItemOnClick(menuItem.id)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "close-round"
      }
    })], 1) : _vm._e(), _vm._v(" "), ((menuItem.closable != true)) ? _c('span', {
      staticClass: "menuitem-space-instead-close-button"
    }, [_vm._v(" ")]) : _vm._e()], 1), _vm._v(" "), _c('MainMenuItems', {
      attrs: {
        "data": menuItem.children,
        "lvl": _vm.lvl + 1,
        "deleteItemOnClick": _vm.deleteItemOnClick
      }
    })], 2) : _vm._e(), _vm._v(" "), (((_vm.mainMenuType.value == _vm.mainMenuType.NARROW) && (menuItem.children != null) && (menuItem.isGroup == true) && (_vm.lvl != 1)) ||
      ((_vm.mainMenuType.value == _vm.mainMenuType.FULLWIDTH) && (menuItem.children != null) && (menuItem.isGroup == true))) ? _c('Menu-group', {
      attrs: {
        "title": menuItem.name
      }
    }, [_c('MainMenuItems', {
      attrs: {
        "data": menuItem.children,
        "lvl": _vm.lvl + 1,
        "deleteItemOnClick": _vm.deleteItemOnClick
      }
    })], 1) : _vm._e(), _vm._v(" "), (((_vm.mainMenuType.value == _vm.mainMenuType.NARROW) && (menuItem.children != null) && (menuItem.isGroup == true) && (_vm.lvl == 1)) ||
      ((_vm.mainMenuType.value == _vm.mainMenuType.NARROW) && (menuItem.children != null) && (menuItem.isGroup != true))) ? _c('Poptip', {
      staticClass: "nostyle-poptip poptip-as-menuitem",
      attrs: {
        "trigger": "hover",
        "placement": "right"
      }
    }, [_c('Menu-item', {
      attrs: {
        "name": menuItem.id
      }
    }, [_c('Icon', {
      class: {
        'menuitem-icon': _vm.lvl != 1, 'menuitem-icon-big': _vm.lvl == 1
      },
      attrs: {
        "type": menuItem.icon
      }
    }), _vm._v(" "), (_vm.lvl != 1) ? _c('span', {
      staticClass: "menuitem-text"
    }, [_vm._v(_vm._s(menuItem.name))]) : _vm._e(), _vm._v(" "), ((menuItem.closable == true) && (_vm.lvl != 1)) ? _c('Button', {
      staticClass: "menuitem-close-button",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.deleteItemOnClick(menuItem.id)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "close-round"
      }
    })], 1) : _vm._e(), _vm._v(" "), ((menuItem.closable != true) && (_vm.lvl != 1)) ? _c('span', {
      staticClass: "menuitem-space-instead-close-button"
    }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.lvl != 1) ? _c('Icon', {
      staticClass: "poptip-submenu-arrow",
      attrs: {
        "type": "chevron-right"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "mainmenu ivu-menu ivu-menu-dark ivu-menu-vertical poptip-content-panel",
      slot: "content"
    }, [_c('MainMenuItems', {
      attrs: {
        "data": menuItem.children,
        "lvl": _vm.lvl + 1,
        "deleteItemOnClick": _vm.deleteItemOnClick
      }
    })], 1)], 1) : _vm._e()], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-520e4330","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu/MainMenuItems.vue
// module id = 398
// module chunks = 0